import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      tbv2: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -10),
        hasta: this.currentdate(),
      }

    };
  },

  mounted: function () {
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      dom: 'Bfrtip',
      buttons: [],
    });
    $('.box').boxWidget();

    //this.consultar();

  },

  computed: {
    reporte: function () {
      return (
        "/reportes/comisiones?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.$http
        .post('/reportes/comisiones', this.f_c)
        .then(response => {
          
          if (response.data.status == 1) {
            response.data.data.forEach(e => {
              for (let i = 9; i < 46; i++) {
                e[i] = this.num_to_many(e[i]);

              }
              this.tbv.row.add(e);
            });
          }
          this.tbv.draw();
          this.loading = false;
        });
    },
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/comisiones/tventas/index.js